// extracted by mini-css-extract-plugin
export default {"subMenu":"styles_subMenu__SBjNk","actions":"styles_actions__lmO9m","spacer":"styles_spacer__RhqrV"};